import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class OemStoreService {
    $oemStoreData: Observable<any>;
    private _oemStoreData: any;// keep something related to device
    private oemStoreDataSubject = new BehaviorSubject<any>(undefined);

    constructor() {
        this.initParams();
    }

    //comment about function
    updateOemData(value: any) {
        const updatedSKU =  value ;
        this._oemStoreData = updatedSKU;
    }

    //comment about function
    clearStoreData() {
        this._oemStoreData = undefined;
    }

    private initParams() {
        this.$oemStoreData = this.oemStoreDataSubject.asObservable();
    }

    get oemStoreData(): any {
        return this._oemStoreData;
    }

    set oemStoreData(value: any) {
        this._oemStoreData = value;
        this.oemStoreDataSubject.next(this._oemStoreData);
    }
}
